import PropTypes from 'prop-types';
import React from 'react';
import { Container } from 'react-bootstrap';
import { ElementCard } from 'src/components/ElementCard/ElementCard';
import { PortableHeader } from 'src/components/PortableHeader/PortableHeader';
import * as styles from './CardsWithSummaries.module.scss';

const Summary = ({ summaryTitle, summaryDescription }) => (
  <div className="mt-7">
    <h5>{summaryTitle}</h5>
    <p className="text-muted">{summaryDescription}</p>
  </div>
);

export const CardsWithSummaries = ({ header, cards: cardsData }) => {
  const cards = cardsData.map(({ _key, cardIcon, cardTitle, cardDescription, summaryTitle, summaryDescription }) => (
    <div key={_key} className={styles.cardWithSummary}>
      <ElementCard icon={cardIcon} title={cardTitle} description={cardDescription} cardStyle={styles.cardStyle} />
      <Summary summaryTitle={summaryTitle} summaryDescription={summaryDescription} />
    </div>
  ));

  return (
    <section className={`${styles.section} py-6`}>
      <Container as="section" className="py-6">
        <PortableHeader content={header} className="mb-8" />

        <div className={styles.cards}>{cards}</div>
      </Container>
    </section>
  );
};

CardsWithSummaries.propTypes = {
  header: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      cardTitle: PropTypes.string.isRequired,
      cardDescription: PropTypes.string.isRequired,
      cardIcon: PropTypes.string.isRequired,
      summaryTitle: PropTypes.string.isRequired,
      summaryDescription: PropTypes.string.isRequired,
    })
  ).isRequired,
};
